import { render, staticRenderFns } from "./ProductsForm.vue?vue&type=template&id=1c4d9d10&scoped=true"
import script from "./ProductsForm.vue?vue&type=script&lang=js"
export * from "./ProductsForm.vue?vue&type=script&lang=js"
import style0 from "./ProductsForm.vue?vue&type=style&index=0&id=1c4d9d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d9d10",
  null
  
)

export default component.exports